import React, { Component } from 'react';
import AiInputTextWrap from './AiInputTextWrap';
import {IMAGE_URL,IMAGE_URL_PROD} from '../constants';
  

//const AiInput = ({ dispatch }) => {
class AiInput extends Component {
  componentWillMount()
  {
  //  console.log('Will mount aiInput')
    /* if (["monogram","nameplate","nameplate2"].includes(this.props.optionE.filter)) {  
        this.props.onReqCharE1()
    }  */ 
  }
  
  render() {
   //console.log('RENDER Input',this.props)
   var rows = [];
   var rows2 = [];
   var children = this.props.childrenE

   
   let metal2name={
    "no":"no",
    "s":"silver",
    "g10w":"silver",
    "g14w":"silver",
    "g10y":"gold",
    "g14y":"gold",
    "spy":"gold",
    "spr":"rose",
    "g10r":"rose",
    "g14r":"rose", 
  }
    
    let base_url=IMAGE_URL
    
    if (window.currentEnv ==='www'){
        base_url =IMAGE_URL_PROD
    }
    
    if (this.props.test === 'yes')
     base_url = base_url.replace('images.','us.')

    for (let i in children) {
     //console.log('constr InputSet',children) 
    // if (children[i].show)
      let view = 1+this.props.lsbefore
    if (children[i].hasOwnProperty('switch_view')) {
      view = parseInt(children[i].switch_view) + parseInt(this.props.lsbefore)
    }
      
    let preview = base_url+"?sku="+this.props.sku+"&text0="+this.props['e'+(rows2.length+1)]+"&material="+metal2name[this.props.m]+"&showpreview=yes"

      rows.push(<AiInputTextWrap 
      id={children[i].attr}  
      name={children[i].name} 
      attr={children[i].attr} 
      value={children[i].value} 
      show={children[i].show} 
      filter={this.props.optionE.filter} 
      switchView={view} 
      key={i.toString()} 
      options_all={this.props.options_all}
      maxLength={children[i].maxLength} />);

      if(children[i].show)
      rows2.push(<div className='ai-np-preview-image-box'>
			<img src={preview} alt="" tabIndex="-1" title="" className="ai-np-preview-image"/>
			<div className="overlay-effect"/>
		  </div>)

   }
   var optional =''
   let fcolor ='ai-color-' + window.currentSite +' ai-option-title'
   let opt ="(optional)"
   if (["monogram","nameplate","nameplate2","initial2"].includes(this.props.optionE.filter)) { 
     opt=''
    // this.props.onReqCharE1()
   }
   //if (!this.props.optionE.preview && this.props.showpreview == ''){ //this.props.name.toUpperCase() !== 'NAME PLATE'){
   if (!this.props.optionE.preview && this.props.showpreview == ''){ //this.props.name.toUpperCase() !== 'NAME PLATE'){
    optional =<div className='ai-option-title-optional'>{opt}</div>
   }
   else {      
    return (
      <div className='ai-np-wrap'>
      <div className='ai-np-input-box'>
        <div className={fcolor}>{this.props.name.toUpperCase()}</div>
        {optional}
        <div className="ai-np-inputtext-wrap ai-show">
      {rows}
      </div>
      
      </div>
      <div  className='ai-np-preview-box'>
        <div className={fcolor + ' ai-np-title'}>PREVIEW</div>
      {rows2}
      </div>
      </div>
  );
   }
  //this.props.onLoadingDone()
   return (
    <div  className='ai-input-box'>
      <div className={fcolor}>{this.props.name.toUpperCase()}</div>
      {optional}
    {rows}
    
    </div>
);
  }
}
export default AiInput;



// WEBPACK FOOTER //
// ./src/layout/AiInput.js